



















































































import { Vue, Component } from "vue-property-decorator";
import logger from "@/configs/logger";
import * as api from "@/lib/api";
import { objectify } from "@/helpers";
import LeadPanel from "@/components/Lead/LeadPanel.vue";

@Component({ components: { LeadPanel } })
export default class LeadLookup extends Vue {
  phoneNumber: string = "";
  firstName: string = "";
  lastName: string = "";
  createIfMissing: boolean | null = null;
  missingPhoneNumber = false;
  loading: boolean = false;
  results: any[] = [];
  activeLeadId: string = "";
  dialog: boolean = false;

  openLead(leadKey: string = ""): void {
    this.activeLeadId = leadKey.split("/")[1];
    this.dialog = true;
  }

  async onSubmit() {
    if (this.phoneNumber) {
      this.missingPhoneNumber = false;
      const opts: any = {};
      if (this.firstName) opts["firstName"] = this.firstName;
      if (this.lastName) opts["lastName"] = this.lastName;
      if (typeof this.createIfMissing === "boolean") {
        opts["createIfMissing"] = this.createIfMissing;
      }
      await this.requestLookup(this.phoneNumber, opts);
    } else {
      this.missingPhoneNumber = true;
    }
  }

  async requestLookup(phoneNumber: string, opts?: any) {
    try {
      this.loading = true;
      const { data } = await api.lookupLead(phoneNumber, opts);
      logger("log", "lookup data", data);
      this.results = data;
    } catch (err) {
      logger("error", "lead lookup error", err);
      // @ts-ignore
      if (err.response.data.error) {
        this.$toasted.error(err.response.data.error).goAway(2000);
      } else {
        this.$toasted.error("Lead lookup error").goAway(2000);
      }
    } finally {
      this.loading = false;
    }
  }
}
